/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_SubtitleInputs */



/**
* | output |
* | --- |
* | "Wundo is your personal sparring partner for the conversations that matter." |
*
* @param {Onboarding_Welcome_SubtitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_subtitle = /** @type {((inputs?: Onboarding_Welcome_SubtitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_SubtitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo is je persoonlijk klankbord voor de gesprekken die ertoe doen!")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo est votre caisse de résonance personnelle pour les conversations qui comptent !")
	return /** @type {LocalizedString} */ ("Wundo is your personal sparring partner for the conversations that matter.")
});